import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, useParams } from "react-router-dom";
import { Container } from 'reactstrap';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const Login = (props) => {
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    let history = useHistory();
    let params = new URLSearchParams(props.location.search);
    const handleLogin = (e) => {
        e.preventDefault();    
        setLoading(true);
     
        axios.post('api/auth/login', { username: username, password: password }, { withCredentials: true }).then(response => {
            if (params.get("origin") == null) {
                history.push('home');
            }
            if (process.env.PUBLIC_URL.length > 0) {
                history.push(params.get("origin").split(process.env.PUBLIC_URL)[1]);
            }
            else {
                history.push(params.get("origin"));
            }
        }).catch(function (error) {
            setShowError(true);           
            if (error.response) {  
                setErrorMessage(error.response.data.message);
            }
            setLoading(false);
        });
    }
    const handleEnter = (e) => {      
        if (e.which === 13) {
            handleLogin(e);
        }
    }


    return (
    <div>
    <Container className="content">
        <h2>Login</h2>
        <p>Your UOW username and password are used solely for the purpose of authentication to ensure that only UOW staff are able to access the tool. </p>
        <p>To ensure your anonymity, <strong>your username and password are not stored within the tool</strong> and are not associated with any data records created by your use of the tool.</p>
        <p>Please login using your UOW username and password.</p>
        {showError ? <span className="error">Something went wrong: {errorMessage} </span> : <span />}
        <p><label htmlFor="username">Username</label><br />
            <input type="text" name="username" onChange={(e) => setUsername(e.target.value)} autoFocus />
            </p>
            <p>
            <label htmlFor="password">Password</label><br />
            <input type="password" name="password" onChange={(e) => setPassword(e.target.value)} onKeyPress={handleEnter} />
            </p>
        <p><button onClick={handleLogin} disabled={loading} className="link-small">Login</button></p>
     
            </Container>
            <div className="page-nav">
                <div><a href="home" className="link-small-back"> Back</a></div>   
            </div>
            </div>

    )
}
const LoginPopup = (props) => {
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleLogin = (e) => {
        e.preventDefault();
        setLoading(true);

        axios.post('api/auth/login', { username: username, password: password }, { withCredentials: true }).then(response => {
            props.onAuthenticated();
        }).catch(function (error) {
            setShowError(true);
            if (error.response) {
                setErrorMessage(error.response.data.message);
            }
            setLoading(false);
        });
    }
    const handleEnter = (e) => {
        if (e.which === 13) {
            handleLogin(e);
        }
    }


    return (
        <Dialog open={props.open} aria-labelledby="form-dialog-title" maxWidth='xl'>
            <DialogTitle id="form-dialog-title" disableTypography={true}><h3>Session time out</h3></DialogTitle>
        <DialogContent>
                <DialogContentText>
                    Your session has timed out, please login to avoid losing your progress. <br /> <br />
            Your UOW username and password are used solely for the purpose of authentication to ensure that only UOW staff are able to access the tool. <br /> <br />
             To ensure your anonymity, your username and password are not stored within the tool and are not associated with any data records created by your use of the tool. <br /> <br />
                Please login using your UOW username and password. <br /> <br />
                    {showError ? <span className="error">Something went wrong: {errorMessage} </span> : <span />}
                   
                   
                  
          </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="username"
                    label="Username"
                    type="username"
                    fullWidth
                    onChange={(e) => setUsername(e.target.value)}
                    autoFocus
                    variant="outlined"
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="password"
                    label="Password"
                    type="password"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setPassword(e.target.value)} onKeyPress={handleEnter}

                />
        </DialogContent>
        <DialogActions>
 
          <Button onClick={handleLogin} className="link-small" >
                    Login
          </Button>
        </DialogActions>
      </Dialog>
    
    )
}



export default Login;
export { LoginPopup };